// src/api/corralCouponsAdminApi.ts
import client from "./client";

export type CorralCouponStatus = "PENDING" | "REDEEMED" | "EXPIRED" | "REVOKED";

export interface CorralCouponAdminItem {
  id: string;
  code: string;
  targetUserId: string;
  targetUserFullName: string;
  targetUserEmail: string | null;
  quantity: number | null;
  unlimited: boolean;
  status: CorralCouponStatus;
  expiresAt: string;
  createdAt: string;
  redeemedAt: string | null;
  createdByAdminName: string | null;
}

interface AdminEnvelope<T> {
  code: number;
  message: string;
  content: T;
  totalElements?: number;
  totalPages?: number;
}

export const corralCouponsAdminApi = {
  listar: (page = 0, size = 20, status?: CorralCouponStatus | "") =>
    client.get<AdminEnvelope<CorralCouponAdminItem[]>>(
      "/api/v1/admin/corrals/coupons",
      { params: { page, size, status: status || undefined } },
    ),

  crear: (payload: {
    targetUserId?: string;
    targetUserEmail?: string;
    quantity?: number;
    unlimited: boolean;
    expiresAt: string;
  }) =>
    client.post<AdminEnvelope<CorralCouponAdminItem>>(
      "/api/v1/admin/corrals/coupons",
      payload,
    ),

  /**
   * Solo funciona sobre cupones PENDING (aún no canjeados) — el backend
   * rechaza revocar uno ya canjeado, vencido o previamente revocado.
   */
  revocar: (id: string) =>
    client.patch<AdminEnvelope<CorralCouponAdminItem>>(
      `/api/v1/admin/corrals/coupons/${id}/revoke`,
    ),
};
